// Gemeinsame Bausteine für Bestellkarte und Kasse.

export const SIDE_DISHES = ["Pommes", "Reis", "Kroketten", "Kartoffelchips", "Bandnudeln"];

export const euro = (amount) => `${amount.toFixed(2).replace(".", ",")} €`;

export const SideDishSelect = ({ value, onChange, className = "", label }) => (
    <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={label}
        className={`field-select ${className}`}
    >
        {SIDE_DISHES.map((side) => (
            <option key={side} value={side}>
                mit {side}
            </option>
        ))}
    </select>
);

export const QuantityStepper = ({ quantity, onDecrease, onIncrease, title, size = 36, max }) => (
    <div className="flex items-center">
        <button
            type="button"
            onClick={onDecrease}
            aria-label={`${title}: eins weniger`}
            className="border border-forest/30 bg-transparent text-lg"
            style={{ width: size, height: size }}
        >
            −
        </button>
        <span className="text-center text-sm" style={{ width: size }} aria-live="polite">
            {quantity}
        </span>
        <button
            type="button"
            onClick={onIncrease}
            disabled={max !== undefined && quantity >= max}
            aria-label={`${title}: eins mehr`}
            className="border border-forest/30 bg-transparent text-lg disabled:opacity-30"
            style={{ width: size, height: size }}
        >
            +
        </button>
    </div>
);

export const Notice = ({ children, tone = "dark" }) =>
    tone === "dark" ? (
        <div role="status" className="bg-forest px-6 py-5 text-[15px] leading-[1.6] text-creme">
            {children}
        </div>
    ) : (
        <div role="status" className="border border-messing px-5 py-3.5 text-sm leading-normal">
            {children}
        </div>
    );
